import React from 'react';
import { Text, useTheme } from '@fluentui/react';
import { Image, ImageFit } from '@fluentui/react/lib/Image';
import SystemClient from '../../system/SystemClient';
import { Equipo } from '../../system/Equipo/Equipo';
import { useContainerStyle } from '../../common/custom-hooks/useStyles';
import { isLightTheme } from '../../App';

interface IPlanillaDigitalTeamCardProps {
  system: SystemClient;
  equipo: Equipo;
  local: boolean;
  goles: number;
  color: string;
}

export const PlanillaDigitalTeamCard = (props: IPlanillaDigitalTeamCardProps) => {
  const containerStyle = useContainerStyle();
  const theme = useTheme();
  return (
    <div className="ms-Grid">
      <div className="ms-Grid-row text-center" style={{ display: 'flex', ...containerStyle }}>
        <div className="ms-Grid-col ms-sm2" style={{ display: 'inline-block', padding: '1rem' }}>
          <Image
            src={
              props.equipo.getClub()?.getEscudo()
                ? props.system.getClubSystem().getUrlForImage(props.equipo.getClub()!.getEscudo())
                : '/planilla-app/img/escudo_default.jpg'
            }
            imageFit={ImageFit.cover}
            maximizeFrame
            styles={{
              root: {
                borderRadius: '50%',
                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                width: '50px',
                height: '50px',
              },
            }}
          />
        </div>
        <div className="ms-Grid-col ms-sm8" style={{ padding: '1rem' }}>
          <div className="ms-Grid-row">
            <Text
              className="mb-1"
              variant="medium"
              style={{
                fontWeight: 600,
                fontSize: 20,
              }}
            >
              {props.equipo.getClub()?.getNombre()} {props.equipo.getNombreOrden()}
            </Text>
          </div>
          <div className="ms-Grid-row">
            <Text
              className="mb-1"
              variant="medium"
              style={{
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              {props.local ? 'Local' : 'Visitante'}
            </Text>
          </div>
        </div>
        <div
          className="ms-Grid-col ms-sm2"
          style={{
            display: 'inline-block',
            padding: '1rem',
            backgroundColor: isLightTheme(theme) ? 'rgb(236 236 236)' : theme.palette.white,
          }}
        >
          <div className="ms-Grid-row">
            <Text
              className="mb-1"
              variant="medium"
              style={{
                fontWeight: 600,
                fontSize: 37,
              }}
            >
              {props.goles}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanillaDigitalTeamCard;
